;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'clsx';

import Text from 'components/ui/Text';

import styles from './EyebrowRibbon.module.scss';

const EyebrowRibbon = ({ children, className, isXLarge }) => {
    return (
        <Text
            className={cx(styles.root, className, {
                [styles.isXLarge]: isXLarge,
            })}
            baseTheme="labelSmall"
        >
            <span className={styles.inner}>{children}</span>
        </Text>
    );
};

export default EyebrowRibbon;
